import {
  Task
} from "../../../API/api.js";
export default {
    components: {},
    props: {
       

    },
    data() {
      return{

      }
    },
    watch: {

    },
    methods:{
      //task/list
//       state:
//         0
// flowState:
//         0
// functionType:
//         0
// toolkitId:
//         page:
//       1
// page_size:
//       25
// orderBy:
//       createTime
// asc:
//         desc
// projectId:
//         is_urgent:
//       productId:
//         7
    },
    mounted() {
       
    },

}
